export enum AdminModelsRoutes {
  GetAllModels = 'all',
  ArchiveModels = 'archive-models',
  ArchiveUnusedModels = 'archive-unused-models',
  CopyModel = 'copy-model',
  CreatedModels = 'created',
  CreateMachineMetric = 'create-machine-metric',
  EvaluateCollectionMachine = 'evaluate-collection-machine',
  EvaluateCollectionModel = 'evaluate-collection-model',
  EvaluateMachineMetrics = 'evaluate-machine-metrics',
  EvaluateModelMetrics = 'evaluate-model-metrics',
  GatherData = 'gather-data',
  GetMachineMetrics = 'get-machine-metrics',
  GetModelMetrics = 'get-model-metrics',
  SummarizeData = 'summarize-data',
  TrainModels = 'train-models',
  TrainModelsFromCollection = 'train-models-from-collection',
  UpdateModel = 'update-model',
}
